import { setBreadcrumbTitle } from "features/breadcrumb/breadcrumbSlice";
import ContentGrid from "features/category/ContentGrid";
import Filters from "features/Filters";
import { PageWithFilterType } from "features/Filters/types";
import { extractActiveFilters } from "features/Filters/utils";
import { FiltersContainer } from "pages/category/Category";
import React, { useEffect, useLayoutEffect, useMemo } from "react";
import { batch, useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components/macro";
import { Desktop, device } from "theme/Breakpoints";
import { fetchFilteredAccessories } from "./accessoriesSlice";
import AccessoryItem from "./components/AccessoryItem";
import { useFetchAccessories } from "./hooks/useFetchAccessories";
import { useSelectFilters } from "pages/category/hooks/useSelectFilters";
import {
  setActiveFilters,
  setActiveFiltersCount,
} from "features/Filters/filtersSlice";
import Categories from "features/categories";
import Pagination from "features/pagination";
import { selectPage } from "features/pagination/paginationSlice";
import ContentTopSection from "features/category/ContentTopSection";

interface AccessoriesProps {}

const Accessories: React.FC<AccessoriesProps> = ({}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(useLocation().search);
  var activeFilters = useMemo(
    () => extractActiveFilters(queryParams),
    [queryParams]
  );

  const page = useSelector(selectPage);
  const { filters, activeFiltersCount } = useSelectFilters(activeFilters);
  var activeFilters = useMemo(
    () => extractActiveFilters(queryParams),
    [queryParams]
  );

  const { accessories, isLoading } = useFetchAccessories(activeFilters);

  //create custom hook
  useLayoutEffect(() => {
    dispatch(setBreadcrumbTitle("Аксесоари"));
    return () => {
      dispatch(setBreadcrumbTitle(""));
    };
  }, []);

  const removeFilters = () => {
    dispatch(setActiveFilters([]));
    dispatch(setActiveFiltersCount(0));
    dispatch(fetchFilteredAccessories([]));
    navigate("/accessories");
  };

  return (
    <AccessoriesContainer>
      <Desktop>
        <FiltersContainer>
          <Filters
            filters={filters}
            activeFiltersCount={activeFiltersCount}
            removeFiltersCB={removeFilters}
            pageType={PageWithFilterType.accessories}
            fetchFN={fetchFilteredAccessories}
          />
          <Categories />
        </FiltersContainer>
      </Desktop>
      <ContentContainer>
        {/* <ContentTopSection itemsLength={isLoading ? 0 : accessories.length} /> */}

        <ContentGrid
          data={accessories}
          ComponentToRender={AccessoryItem}
          isLoading={isLoading}
        />
        {accessories.length > 0 && <Pagination disabled={isLoading} />}
      </ContentContainer>
    </AccessoriesContainer>
  );
};

const AccessoriesContainer = styled.div`
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-start;
  gap: 20px;
  padding: 16px 0 30px;

  @media only screen and (${device.tablet}) {
    padding-top: 30px;
  }
`;

const ContentContainer = styled.div`
  box-sizing: border-box;
  flex: 1 1 auto;
  width: auto;
  min-width: 0;
  padding: 0 12px;

  @media only screen and (${device.tablet}) {
    padding: 0 20px;
  }
`;

const StyledH3 = styled.h3`
  color: black;
  text-align: center;
  margin: 10px;

  @media only screen and (${device.tablet}) {
    text-align: start;
  }
`;

export default Accessories;
